const CAMPAIGN_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  ARCHIVED: 'archived',
}

const CAMPAIGN_TYPE = {
  AB: 'a/b',
  DEFAULT: 'default',
}

export { CAMPAIGN_STATUS, CAMPAIGN_TYPE }